import React from 'react';
import { HomeMosaic } from './dashboard/HomeMosaic';
import { People } from './dashboard/People';
import { Events } from './dashboard/Events';
import { Archive } from './dashboard/Archive';
import { Voices } from './dashboard/Voices';
import { Profile } from './dashboard/Profile';
import { MemorialProfile } from './dashboard/MemorialProfile';
import type { PortalSection } from '../components/layout/AppShell';
import type { Member } from '../data/community';
interface DashboardProps {
  section: PortalSection;
  sparse: boolean;
  onNavigate: (section: PortalSection) => void;
  profileOf: Member | null;
  onOpenProfile: (member: Member) => void;
}
export function Dashboard({
  section,
  sparse,
  onNavigate,
  profileOf,
  onOpenProfile
}: DashboardProps) {
  if (section === 'profile' && profileOf) {
    if (profileOf.memorial) {
      return <MemorialProfile member={profileOf} onBack={() => onNavigate('people')} data-id="element-560" data-mp="1wbaf4tog48f4" />;
    }
    return <Profile member={profileOf} onBack={() => onNavigate('people')} data-id="element-561" data-mp="1rdinm0rpqobg" />;
  }
  if (section === 'people') return <People sparse={sparse} onOpenProfile={onOpenProfile} data-id="element-562" data-mp="21p58m618o52i" />;
  if (section === 'events') return <Events onOpenProfile={onOpenProfile} data-id="element-563" data-mp="26n6nsfvjnk8p" />;
  if (section === 'archive') return <Archive data-id="element-564" data-mp="2bnky64kmb69w" />;
  if (section === 'voices') return <Voices data-id="element-565" data-mp="2blq9qga50w12" />;
  return <HomeMosaic sparse={sparse} onOpenPeople={() => onNavigate('people')} data-id="element-566" data-mp="2fpfvyz3cb1ix" />;
}